import styled from 'styled-components';
import { SortingDropdown } from '../../../shared/filter-dropdown/filter-dropdown.component';

export const SortingHeader = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledFilterDropDown = styled(SortingDropdown)``;
